// extracted by mini-css-extract-plugin
export default {"textHeading":"services_textHeading__y7jUr","servText":"services_servText__V9JQi","mainDiv":"services_mainDiv__Ciucd"};